import { CommonModule } from '@angular/common';
import { Component, Input, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-protocol-info-bottom-sheet',
  templateUrl: './protocol-info-bottom-sheet.component.html',
  styleUrls: ['./protocol-info-bottom-sheet.component.css'],
  imports: [ CommonModule]
})
export class ProtocolInfoBottomSheetComponent implements OnInit {

  @Input() sheetText: string;

  constructor(private bottomSheetRef: MatBottomSheetRef<ProtocolInfoBottomSheetComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
  }

  public ngOnInit(): void {
  }

  //protocolDta: protocol,
  //sectionData: sectionsData


  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
